/**
 * Hook to detect HTML zone (Header/Body/Footer) for an element
 * @param ref - React ref of the element
 * @returns HTML zone string
 */
export const useHTMLZone = (): string => {
  if (typeof window === 'undefined') return 'Body';

  return 'Body'; // Default, will be determined by context
};

/**
 * Detect HTML zone from element
 * @param element - HTML element
 * @returns HTML zone (Header/Body/Footer)
 */
export const detectHTMLZone = (element: HTMLElement): string => {
  // Walk up the DOM tree to find the zone
  let current: HTMLElement | null = element;
  
  while (current) {
    const tagName = current.tagName?.toLowerCase();
    
    // Check for semantic HTML tags
    if (tagName === 'header' || current.className?.includes('header')) {
      return 'Header';
    }
    if (tagName === 'footer' || current.className?.includes('footer')) {
      return 'Footer';
    }
    if (tagName === 'main') {
      return 'Body';
    }
    
    current = current.parentElement;
  }
  
  return 'Body'; // Default
};
